// Return a complete range or reject it; callers must never advance past failed reads.
export async function readLogRange({ fromBlock, toBlock, address, topics, getLogs, getBlock }) {
  try {
    return await getLogs({ address, topics, fromBlock, toBlock });
  } catch (error) {
    // Some providers need block hashes for short ranges. Keep fallback bounded.
    if (toBlock - fromBlock > 5) throw error;
    const logs = [];
    for (let blockNumber = fromBlock; blockNumber <= toBlock; blockNumber += 1) {
      const block = await getBlock(blockNumber);
      if (!block?.hash) throw new Error('RPC returned a block without a hash');
      logs.push(...await getLogs({ address, topics, blockHash: block.hash }));
    }
    return logs;
  }
}
